<!-- PROFILE PAGE -->
<div class="container d-flex align-item-center justify-content-center mt-md-5 visible" id="profile_section">
    <div class="row">
        <div class="card p-4">
            <div class="card-body">
                <div class="progress_img mb-2">
                    <img src="../../../assets/img/verify.svg" alt="verify" class="img-fluid">
                </div>
                <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <img src="../../../assets/img/profile.svg" alt="verify" class="img-fluid d-block ml-auto mr-auto mt-3">
                <h5 class="card-title text-light font-weight-bold text-center mt-3"> PROFILE</h5>
                <p class="card-text text-center">We will send you a one time password on this mobile number</p>
                <form class="form_profile">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-default">
                                <i class="fa fa-user" aria-hidden="true"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control" placeholder="Enter your name" type="text" [(ngModel)]="name" name="name" required>
                    </div>
                    <div>
                        <button type="button" class="btn btn-danger w-100 profile_btn" (click)="profile()">NEXT</button>
                    </div>

                    <!-- <p class="already_para text-dark d-flex justify-content-center align-item-center mt-3">Already registered?&nbsp;
                        <a class="font-weight-bold">Sign in</a></p> -->
                </form>
            </div>
        </div>
    </div>
</div>